"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  var a = new Uint32Array(4); // we want 4 32bit values

  return Array.from(window.crypto.getRandomValues(a)).map(function (i) {
    return i.toString(16);
  }).join('-');
};

exports.default = _default;